import PublicH1 from 'developer-docs-shared-components/components/PublicH1';
import MdxHeader from './MdxHeader';
import { Text } from 'foundations-components/components/Text';
import { useDevDocsTheme } from 'developer-docs-shared-components/config/themes';
import { jsx as _jsx } from "react/jsx-runtime";
const TextH1 = props => /*#__PURE__*/_jsx(Text, Object.assign({}, props, {
  as: "h1"
}));
function MdxH1(props) {
  const {
    children
  } = props;
  const {
    isPublicTheme
  } = useDevDocsTheme();
  return /*#__PURE__*/_jsx(MdxHeader, {
    marginBlockStart: "0",
    marginBlockEnd: "400",
    Component: isPublicTheme ? PublicH1 : TextH1,
    children: children
  });
}
export default MdxH1;